<template>
  <div class="legal-minimum-wage-validation-result-table">
    <v-data-table
      :headers="headers"
      :items="results"
      :rows-per-page-items="rowsPageItems"
      class="elevation-1 ml-2"
      rows-per-page-text="Verstösse pro Seite"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <div
              v-for="(input, inputIndex) in props.item.inputValues"
              :key="inputIndex"
            >
              {{ input.code }}: {{ input.value }}
            </div>
          </td>
          <td>
            <div>Basisstundenlohn: {{ props.item.gotBasisstundenlohn }}</div>
            <div>Anteil13ML: {{ props.item.GotAnteil13Monatslohn }}</div>
            <div>
              Entschädigung: {{ props.item.GotEntschaedigung13Monatslohn }}
            </div>
          </td>
          <td>
            {{
              props.item.result == 1 || props.item.result == 3
                ? props.item.expectedBasisstundenlohn
                : props.item.expectedBasisstundenlohnPlus13ML
            }}
          </td>
          <td>
            <v-checkbox
              :input-value="props.item.result == 2 || props.item.result == 4"
              :disabled="true"
              hide-details
              density="compact"
              class="mt-0"
            />
          </td>
          <td>
            {{ getScopeLabel(props.item.checkedAgainstMinimalSalaryForScope) }}
          </td>
        </tr>
      </template>
      <template v-slot:page-text="{ pageStart, pageStop, itemsLength }">
        <div class="pa-2">
          {{ pageStart }}-{{ pageStop }} von {{ itemsLength }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { GetDisplayValueOfPath } from "@/helpers/PlzHelper.js";
import { GetFullMonthList, GetMonthRangeLabel } from "@/helpers/DateHelper";

export default {
  name: "LegalMinimumWageValidationResultTable",
  props: {
    results: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: "Eingabe", value: "inputValues", sortable: false },
        { text: "Erhaltene Werte", value: "gotValues", sortable: false },
        { text: "Erwarteter Lohn", value: "expectedWage", sortable: false },
        {
          text: "Inklusive 13. Monatslohn?",
          value: "inklusive13ML",
          sortable: false,
        },
        { text: "Verstösst gegen", value: "scope", sortable: false },
      ],
      rowsPageItems: [10, 25, 50, 100, { text: "Alle", value: -1 }],
    };
  },
  computed: {
    monthList() {
      return GetFullMonthList();
    },
  },
  methods: {
    getScopeLabel(scope) {
      const scopeParts = scope.split("|");
      const validFrom = scopeParts[0] ? scopeParts[0] : null;
      const validTo = scopeParts[1] ? scopeParts[1] : null;
      const scopePath = scopeParts[2] ? scopeParts[2] : null;

      const monthLabel = GetMonthRangeLabel(validFrom, validTo);
      const pathLabel = GetDisplayValueOfPath(
        scopePath,
        this.$store.state.mindestLohnKonfiguration.Cities,
      );

      return `${pathLabel} (${monthLabel})`;
    },
  },
};
</script>

<style scoped>
.legal-minimum-wage-validation-result-table {
  padding: 1rem;
}
</style>
